import { consentGiven } from '../components/Molecules/CookieDisclaimer'
import { readUser } from './Authentication'

const parseAuthCookieInfo = () => {
    const user = readUser()
    if (user === null) {
        return {
            user_id: "unknown",
            groups: "",
            study_id: ""
        }
    }
    if (user["provider"] === "google") {
        return {
            user_id: "google-developer",
            groups: "",
            study_id: ""
        }
    }
    return {
        user_id: user.sub,
        groups: user.groups,
        study_id: user.studyid,
    }
}

const pageViewEvent = (path, title) => {
    if (window.gtag && consentGiven()) {
        window.gtag('event', 'page_view', {
            page_location: window.location.href,
            page_path: path,
            page_title: title,
            ...parseAuthCookieInfo()
        })
    }
}

const searchEvent = (searchValue) => {
    if (window.gtag && consentGiven()) {
        window.gtag('event', 'search', {
            search_term: searchValue,
            ...parseAuthCookieInfo()
        })
    }
}

const buttonClickEvent = (buttonName) => {
    if (window.gtag && consentGiven()) {
        window.gtag('event', 'button_click', {
            button_name: buttonName,
            ...parseAuthCookieInfo()
        })
    }
}

const clauseClickEvent = (clauseId) => {
    if (window.gtag && consentGiven()) {
        window.gtag('event', 'clause_click', {
            clause_id: clauseId,
            ...parseAuthCookieInfo()
        })
    }
}

const modelClickEvent = (model) => {
    if (window.gtag && consentGiven()) {
        window.gtag('event', 'model_click', {
            model: model,
            ...parseAuthCookieInfo()
        })
    }
}

const searchResultClick = (searchType, orderOfTheResult) => {
    if (window.gtag && consentGiven()) {
        window.gtag('event', 'search_result_click', {
            search_type: searchType,
            order: orderOfTheResult,
            ...parseAuthCookieInfo()
        })
    }
}

export { buttonClickEvent, pageViewEvent, searchEvent, clauseClickEvent, modelClickEvent, searchResultClick }